import { FC, useState } from 'react';
import cn from 'classnames';
import styles from './LandscapeTextBlockAddPage.module.css';
import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';
import { getUUID } from '../../../utils/UUID';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import {
  fetchBlocks,
  saveRichTextBlock,
} from '../../../store/landscapeAPI/block/reducers/block.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { RichTextBlockResponseDto } from '../../../store/landscapeAPI/block/dto/response/rich-text-block-response.dto';
import { RichTextBlockSaveRequestDto } from '../../../store/landscapeAPI/block/dto/request/rich-text-block-save-request.dto';
import { LandscapeTextBlockAddTemplate } from '../../templates';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeTextBlockAddPageProps {}

const LandscapeTextBlockAddPage: FC<LandscapeTextBlockAddPageProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id, storyId } = useParams();
  const navigate = useNavigate();
  const [textBlock, setTextBlock] = useState<RichTextBlockResponseDto>({
    content: '',
    blockType: BlockType.RichTextBlock,
    compactId: id ?? '',
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { richTextBlockStatus: status } = useSelector(
    (state: RootState) => state.blockSlice
  );

  const handleOnChange = (textBlock: RichTextBlockResponseDto) => {
    setTextBlock(textBlock);
  };

  const callbackFn = async (textBlock: RichTextBlockResponseDto) => {
    const textBlockToSave: RichTextBlockSaveRequestDto = {
      content: textBlock.content,
      blockType: textBlock.blockType,
      compactId: textBlock.compactId,
      id: textBlock.id,
      published: textBlock.published,
      entityType: 'compactstory',
      entityId: storyId ?? '',
    };
    await dispatch(saveRichTextBlock(textBlockToSave));
    dispatch(
      fetchBlocks({
        id: storyId!,
        type: 'compactstory',
        language: LocalesLanguagesConstants.en,
      })
    );
    navigate(
      `/landscapes/edit/${id}/updates/story/edit/${storyId}/content-blocks`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <LandscapeTextBlockAddTemplate
        handleOnChange={handleOnChange}
        textBlock={textBlock}
        callbackFn={callbackFn}
      />
    </div>
  );
};

export default LandscapeTextBlockAddPage;
